const data = {
	US: {
		name: "USA",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/business-nic-hero-2024.jpg",
				url: "https://ignitepouches.com/",
				category: "Nicotine Pouches",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0023/0080/5190/files/ENERGYPOUCHFRAMEX2.png",
				url: "https://ignite.co/pages/energy-caffeine-pouches",
				category: "Energy Pouches",
			},
		],
	},
	RU: {
		name: "Russia",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
			url: "https://puffignite.co/",
			category: "VAPES",
		}, ],
	},
	GT: {
		name: "Guatemala",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	PA: {
		name: "Panama",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	SV: {
		name: "El Salvador",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	HN: {
		name: "Honduras",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	NI: {
		name: "Nicaragua",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	CR: {
		name: "Costa Rica",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	MX: {
		name: "Mexico",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0023/0080/5190/files/ENERGYPOUCHFRAMEX2.png",
				url: "https://ignite.co/pages/energy-caffeine-pouches",
				category: "Energy Pouches",
			},
		],
	},
	CO: {
		name: "Colombia",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	AG: {
		name: "Antigua and Barbuda",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	BS: {
		name: "Bahamas",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	BB: {
		name: "Barbados",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	BZ: {
		name: "Belize",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	CU: {
		name: "Cuba",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	DM: {
		name: "Dominica",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	DO: {
		name: "Dominican Republic",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	GD: {
		name: "Grenada",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	HT: {
		name: "Haiti",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	JM: {
		name: "Jamaica",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	KN: {
		name: "Saint Kitts and Nevis",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	LC: {
		name: "Saint Lucia",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	VC: {
		name: "Saint Vincent and the Grenadines",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	TT: {
		name: "Trinidad and Tobago",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	MD: {
		name: "Moldova",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
			url: "https://puffignite.co/",
			category: "VAPES",
		}, ],
	},
	FR: {
		name: "France",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/business-nic-hero-2024.jpg",
				url: "https://ignitepouches.com/",
				category: "Nicotine Pouches",
			},
		],
	},
	RO: {
		name: "Romania",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/business-nic-hero-2024.jpg",
				url: "https://ignitepouches.com/",
				category: "Nicotine Pouches",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	SK: {
		name: "Slovakia",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
			url: "https://puffignite.co/",
			category: "VAPES",
		}, ],
	},
	PL: {
		name: "Poland",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/business-nic-hero-2024.jpg",
				url: "https://ignitepouches.com/",
				category: "Nicotine Pouches",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	PT: {
		name: "Portugal",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
			url: "https://puffignite.co/",
			category: "VAPES",
		}, ],
	},
	JP: {
		name: "Japan",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
			url: "https://puffignite.co/",
			category: "VAPES",
		}, ],
	},
	KR: {
		name: "Korea",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
			url: "https://puffignite.co/",
			category: "VAPES",
		}, ],
	},
	LT: {
		name: "Lithuania",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/business-nic-hero-2024.jpg",
				url: "https://ignitepouches.com/",
				category: "Nicotine Pouches",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	IT: {
		name: "Italy",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/business-nic-hero-2024.jpg",
			url: "https://ignitepouches.com/",
			category: "Nicotine Pouches",
		}, ],
	},
	HU: {
		name: "Hungary",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	MY: {
		name: "Malaysia",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	CA: {
		name: "Canada",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0023/0080/5190/files/ENERGYPOUCHFRAMEX2.png",
				url: "https://ignite.co/pages/energy-caffeine-pouches",
				category: "Energy Pouches",
			},
		],
	},
	BR: {
		name: "Brazil",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	PY: {
		name: "Paraguay",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	GB: {
		name: "United Kingdom",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/business-nic-hero-2024.jpg",
				url: "https://ignitepouches.com/",
				category: "Nicotine Pouches",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	DE: {
		name: "Germany",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/business-nic-hero-2024.jpg",
				url: "https://ignitepouches.com/",
				category: "Nicotine Pouches",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	ZA: {
		name: "South Africa",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
			{
				img: "https://corporate.ignite.co/wp-content/uploads/2024/09/bottom-our-business-dricus-2024.jpg",
				url: "http://ignitebeverage.com/",
				category: "BEVERAGES",
			},
		],
	},
	CZ: {
		name: "Czech Republic",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	AM: {
		name: "Armenia",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	SE: {
		name: "Sweden",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	GE: {
		name: "Georgia",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	IL: {
		name: "Israel",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	ID: {
		name: "Indonesia",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/business-nic-hero-2024.jpg",
				url: "https://ignitepouches.com/",
				category: "Nicotine Pouches",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	AU: {
		name: "Australia",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	NZ: {
		name: "New Zealand",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	// Middle East
	IR: {
		name: "Iran",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	IQ: {
		name: "Iraq",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/business-nic-hero-2024.jpg",
				url: "https://ignitepouches.com/",
				category: "Nicotine Pouches",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	LB: {
		name: "Lebanon",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/business-nic-hero-2024.jpg",
				url: "https://ignitepouches.com/",
				category: "Nicotine Pouches",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	SY: {
		name: "Syria",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	JO: {
		name: "Jordan",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	SA: {
		name: "Saudi Arabia",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/business-nic-hero-2024.jpg",
				url: "https://ignitepouches.com/",
				category: "Nicotine Pouches",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	YE: {
		name: "Yemen",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	OM: {
		name: "Oman",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	BH: {
		name: "Bahrain",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	QA: {
		name: "Qatar",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	AE: {
		name: "United Arab Emirates",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/business-nic-hero-2024.jpg",
				url: "https://ignitepouches.com/",
				category: "Nicotine Pouches",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	KW: {
		name: "Kuwait",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/business-nic-hero-2024.jpg",
				url: "https://ignitepouches.com/",
				category: "Nicotine Pouches",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	EG: {
		name: "Egypt",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	TR: {
		name: "Turkey",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	CY: {
		name: "Cyprus",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	// END Middle East

	// North Africa
	LY: {
		name: "Libya",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	TN: {
		name: "Tunisia",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	DZ: {
		name: "Algeria",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	MA: {
		name: "Morocco",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/9_ignite-lifestyle.webp",
				url: "https://puffignite.co/",
				category: "VAPES",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/business-nic-hero-2024.jpg",
				url: "https://ignitepouches.com/",
				category: "Nicotine Pouches",
			},
			{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
		],
	},
	SD: {
		name: "Sudan",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	EH: {
		name: "Western Sahara",
		products: [{
			img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
			url: "https://ignitespirits.co/",
			category: "SPIRITS",
		}, ],
	},
	// END North Africa

	IN: {
		name: "India",
		products: [{
				img: "https://cdn.shopify.com/s/files/1/0583/3516/6541/files/1_Hero-family-product.webp",
				url: "https://ignitespirits.co/",
				category: "SPIRITS",
			},
			{
				img: "https://corporate.ignite.co/wp-content/uploads/2024/09/bottom-our-business-dricus-2024.jpg",
				url: "http://ignitebeverage.com/",
				category: "BEVERAGES",
			},
		],
	},
};

const countries = document.querySelectorAll("svg path");
const popup = document.getElementById("popup");
const mapContainer = document.getElementById("map-container");
const categoryButtons = document.querySelectorAll(".cat-btn");
const mobileCategoryWrap = document.querySelector(
	".mobile-category-products"
);
const isMobile = () => window.innerWidth <= 799.98;

let currentCountryId = null;

// --- DRAGGABLE LOGIC START ---
let isDragging = false;
let offsetX, offsetY;

popup.addEventListener("mousedown", function(e) {
	isDragging = true;
	offsetX = e.clientX - popup.offsetLeft;
	offsetY = e.clientY - popup.offsetTop;
	popup.style.cursor = "move";
});

document.addEventListener("mousemove", function(e) {
	if (isDragging) {
		e.preventDefault();
		popup.style.left = `${e.clientX - offsetX}px`;
		popup.style.top = `${e.clientY - offsetY}px`;
	}
});

document.addEventListener("mouseup", function() {
	isDragging = false;
	popup.style.cursor = "default";
});

popup.addEventListener("dragstart", function(e) {
	e.preventDefault();
});
// --- DRAGGABLE LOGIC END ---

// Country click handler
countries.forEach((country) => {
	country.addEventListener("click", (e) => {
		const countryId = country.getAttribute("id");
		const isActive = country.classList.contains("active");

		document
			.querySelectorAll("svg path.active")
			.forEach((c) => c.classList.remove("active"));
		popup.style.display = "none";

		if (isActive) {
			// Deselect country and remove category active states
			country.classList.remove("active");
			categoryButtons.forEach((btn) => btn.classList.remove("active"));

			if (isMobile()) {
				mobileCategoryWrap.innerHTML = "";
			}
			return;
		}

		country.classList.add("active");
		categoryButtons.forEach((btn) => btn.classList.remove("active"));

		if (isMobile()) {
			mobileCategoryWrap.innerHTML = "";
		}

		if (data[countryId] && data[countryId].products.length > 0) {
			currentCountryId = countryId;
			showPopup(e, country);

			const productCategories = data[countryId].products.map((p) =>
				p.category.toLowerCase()
			);
			categoryButtons.forEach((btn) => {
				if (productCategories.includes(btn.dataset.id.toLowerCase())) {
					btn.classList.add("active");
				}
			});
		}
	});
});

// Show popup for country
function showPopup(event, countryElement) {
	const countryRect = countryElement.getBoundingClientRect();

	const {
		name,
		products
	} = data[currentCountryId];
	let productHTML = products
		.map(
			(p) => `
    <a href="${p.url}" target="_blank">
        <img src="${p.img}" alt="Product Image" style="display:block;">
    </a>
`
		)
		.join("");

	popup.innerHTML = `
    <div class="popup-product-wrap">${productHTML}</div>
    <div class="country-name">${name}</div>
`;
	popup.style.display = "block";

	// Delay to ensure popup is rendered before measuring
	requestAnimationFrame(() => {
		const popupWidth = popup.offsetWidth;
		const popupHeight = popup.offsetHeight;

		let left = countryRect.right + 10; // Always to the right
		let top = countryRect.top + countryRect.height / 2 - popupHeight / 2;

		// Adjust if popup goes off screen
		if (left + popupWidth > window.innerWidth) {
			left = countryRect.left - popupWidth - 10;
		}
		if (top < 0) top = 10;
		if (top + popupHeight > window.innerHeight) {
			top = window.innerHeight - popupHeight - 10;
		}

		popup.style.position = "fixed"; // So it's not limited by parent clipping
		popup.style.left = `${left}px`;
		popup.style.top = `${top}px`;
	});
}

// Category button click
categoryButtons.forEach((btn) => {
	btn.addEventListener("click", () => {
		const isActive = btn.classList.contains("active");

		if (isMobile()) {
			categoryButtons.forEach((b) => b.classList.remove("active"));
			if (!isActive) btn.classList.add("active");
		} else {
			btn.classList.toggle("active");
		}

		const activeCategories = Array.from(categoryButtons)
			.filter((b) => b.classList.contains("active"))
			.map((b) => b.dataset.id.toLowerCase());

		document
			.querySelectorAll("svg path")
			.forEach((c) => c.classList.remove("active"));
		popup.style.display = "none";

		for (let countryId in data) {
			const countryElements = document.querySelectorAll(
				`svg path[id="${countryId}"]`
			);
			if (!countryElements.length) continue;

			const hasMatch = data[countryId].products.some((p) =>
				activeCategories.includes(p.category.toLowerCase())
			);

			if (hasMatch) {
				countryElements.forEach((el) => el.classList.add("active"));
			}
		}

		if (isMobile()) {
			mobileCategoryWrap.innerHTML = "";

			if (activeCategories.length) {
				for (let countryId in data) {
					const countryData = data[countryId];
					const matchedProducts = countryData.products.filter((p) =>
						activeCategories.includes(p.category.toLowerCase())
					);

					if (matchedProducts.length) {
						const countryBlock = document.createElement("div");
						countryBlock.classList.add("country-block");
						countryBlock.innerHTML = `
                            <h4>
                                <a href="${matchedProducts[0].url}" target="_blank">
                                    ${countryData.name}
                                </a>
                            </h4>
                            <div class="product-list">
                                ${matchedProducts
                                    .map(
                                    (p) => `
                                    <a href="${p.url}" target="_blank">
                                        <img src="${p.img}" alt="Product Image">
                                    </a>
                                `
                                    )
                                    .join("")}
                            </div>
                        `;
						mobileCategoryWrap.appendChild(countryBlock);
					}
				}
			}
		}
	});
});

// Hide popup and remove highlights when clicking outside
document.addEventListener("click", (e) => {
	const clickedInsideMap = e.target.closest("svg");
	const clickedInsidePopup = e.target.closest("#popup");
	const clickedCatBtn = e.target.closest(".cat-btn");

	if (clickedInsideMap || clickedInsidePopup || clickedCatBtn) return;

	popup.style.display = "none";
	document
		.querySelectorAll("svg path.active")
		.forEach((c) => c.classList.remove("active"));
	categoryButtons.forEach((btn) => btn.classList.remove("active"));

	if (isMobile()) {
		mobileCategoryWrap.innerHTML = "";
	}
});

function isMapVisible() {
	const rect = mapContainer.getBoundingClientRect();
	return rect.bottom >= 0 && rect.top <= window.innerHeight - 200;
}

function handleScrollVisibility() {
	if (!isMapVisible()) {
		popup.style.display = "none";
		document
			.querySelectorAll("svg path.active")
			.forEach((c) => c.classList.remove("active"));
	}
}

window.addEventListener("scroll", handleScrollVisibility);
window.addEventListener("resize", handleScrollVisibility);